<template>
  <div>
    <div
      v-for="(range, index) in ranges"
      :key="index"
      class="inline-form-group black-text"
    >
      <el-col :span="8">
        <omnia-time-select
          start="00:00"
          end="23:59"
          step="00:05"
          title="Start time"
          :isDisabled="disabled"
          :minTime="index > 0 ? ranges[index - 1].endTime : undefined"
          :value="ranges[index].startTime"
          @onTimeSelected="ranges[index].startTime = $event"
        />
      </el-col>
      <el-col :span="2"><p class="text-center">to</p></el-col>
      <el-col :span="8">
        <omnia-time-select
          start="00:00"
          end="23:59"
          step="00:05"
          title="End time"
          :minTime="ranges[index].startTime"
          :isDisabled="disabled"
          :value="ranges[index].endTime"
          @onTimeSelected="onEndTimeSelection(ranges[index], $event)"
        />
      </el-col>
      <el-col :span="1" />
      <el-col :span="2">
        <el-button
          size="mini"
          class="table-action-button icon-red"
          icon="el-icon-delete"
          @click="removeTimeRange(index)"
        />
      </el-col>
    </div>
    <el-button
      v-if="!notAllowedToAddTimeRange"
      size="mini"
      class="mt-5 mb-10"
      icon="el-icon-circle-plus-outline"
      :disabled="notAllowedToAddTimeRange"
      @click="addTimeRange"
      >Add Time Block
    </el-button>
  </div>
</template>

<script>
import OmniaTimeSelect from "@/components/OmniaTimeSelect.vue";
export default {
  name: "MultiTimeRangeSelector",

  props: {
    disabled: { required: true },
    values: { required: true }
  },

  components: {
    OmniaTimeSelect
  },

  data() {
    return {
      ranges: [
        {
          startTime: "",
          endTime: ""
        }
      ]
    };
  },

  watch: {
    values: {
      immediate: true,
      handler(val) {
        if (val && val.length > 0) {
          this.ranges = [...val];
        } else {
          this.ranges = [
            {
              startTime: "",
              endTime: ""
            }
          ];
        }
      }
    }
  },

  computed: {
    notAllowedToAddTimeRange() {
      const lastIdx = this.ranges.length - 1;
      if (this.ranges[lastIdx]) {
        return (
          !this.ranges[lastIdx].startTime ||
          !this.ranges[lastIdx].endTime ||
          this.disabled
        );
      } else {
        return true;
      }
    }
  },

  methods: {
    addTimeRange() {
      this.ranges.push({
        startTime: "",
        endTime: ""
      });
    },

    removeTimeRange(index) {
      this.ranges.splice(index, 1);
      this.emitTimeRangeSelectedEvent();

      if (this.ranges.length === 0) {
        this.addTimeRange();
      }
    },

    onEndTimeSelection(range, endTime) {
      range.endTime = endTime;
      this.emitTimeRangeSelectedEvent();
    },

    emitTimeRangeSelectedEvent() {
      this.$emit("timeRangeSelected", this.ranges);
    }
  }
};
</script>

<style></style>
